import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-calculated-metric',
  templateUrl: './help-add-calculated-metric.component.html',
  styleUrls: ['./help-add-calculated-metric.component.scss']
})
export class HelpAddCalculatedMetricComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
